import { api } from './api';

export interface CouponBenefits {
  readonly code: string;
  readonly description: string;
  readonly percentOff: number | null;
  readonly freeShipping: boolean;
  readonly waiveMinimum: boolean;
}

interface ValidateCouponResponse {
  readonly valid: boolean;
  readonly error: string | null;
  readonly coupon?: CouponBenefits;
}

export const couponsApi = {
  validate: async (code: string): Promise<ValidateCouponResponse> => {
    const result = await api.post<ValidateCouponResponse>('/coupons/validate', { code });
    if (!result.data) {
      throw new Error('Failed to validate coupon');
    }
    return result.data;
  },
};
